// extracted by mini-css-extract-plugin
export var articleMultipleChoiceCTA = "bR_fB";
export var mainHeader = "bR_fW";